// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2-_ZY","alert":"SettungsInbox_alert__2Ofzp"};